import { userImpersonationStore } from "src/slices/facility-forms-management/impersonation/impersonation-interface";

export const initialState: userImpersonationStore = {
  users: [],
  isLoading: false,
  isAddZeusUserLoading: false,
  isImpersonationLoading: false,
};
